import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Images, Logos } from "../../data/Assets";

import SignInView from "../views/auth/SignIn";
// import SignUpView from "../views/auth/SignUp";
import ForgotPasswordView from "../views/auth/ForgotPassword";
import ResetPasswordView from "../views/auth/ResetPassword";
import { ImageAsset } from "../wrappers/ImageAsset";
// import ActivateAccountView from "../views/auth/ActivateAccount";

const AuthPage = () => {
    const { view } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            // view !== "sign-up" &&
            // view !== "activate-account" &&
            view !== "sign-in" &&
            view !== "forgot-password" &&
            view !== "reset-password" &&
            view !== "set-password"
        ) {
            navigate("/auth/sign-in");
        };

        // eslint-disable-next-line
    }, [view]);

    return (
        <div className="immployer__auth__page_view">
            <div className="immployer__auth_bg__section">
                <ImageAsset src={Logos.Logo} alt="" className="immployer__auth_logo" />
                <ImageAsset src={Images.GlobalTalentStream} alt="" className="immployer__auth_bg1" />
                <ImageAsset src={Images.HappySearch} alt="" className="immployer__auth_bg2" />
                <ImageAsset src={Images.Chart} alt="" className="immployer__auth_bg3" />
            </div>
            <div className="immployer__auth_forms__section">
                {
                    view === "sign-in"
                        ? <SignInView />
                        // : view === "sign-up"
                        //     ? <SignUpView />
                        // : view === "activate-account"
                        //     ? <ActivateAccountView />
                        : view === "forgot-password"
                            ? <ForgotPasswordView />
                            : view === "reset-password" || view === "set-password"
                                ? <ResetPasswordView />
                                : null
                }
            </div>
        </div>
    );
};

export default AuthPage;